import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
//import Visie from './views/Visie.vue';
import Team from './views/Team.vue';
import Contact from './views/Contact.vue';
//import Links from './views/Links.vue';

Vue.use(Router);
export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/home',
			redirect: '/'
		},
		
		/*
		{
			path: '/visie',
			name: 'visie',

			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: Visie,
		},
		*/
		{
			path: '/team',
			name: 'team',
			component: Team,
		},
		{
			path: '/contact',
			name: 'contact',
			component: Contact,
		},
		/*
		{
			path: '/links',
			name: 'links',
			component: Links,
		},
		*/
		{
			path: '/',
			name: 'home',
			component: Home,
		},
		{
			path: '/*',
			redirect: '/'
		},
		{
			path: '*',
			name: '404',
			component: 404
		}
	],
});
